import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { fadeInRule } from 'shared-assets/lib/animations';

import Spinner from '../Spinner';

const Mask = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  animation: ${fadeInRule};
  background: rgba(255, 255, 255, 0.8);
  z-index: 2;
  border-radius: ${props => props.borderRadius};
`;

export default class LoadingOverylay extends React.PureComponent {
  static defaultProps = {
    borderRadius: '3px',
    children: null,
    isLoading: false,
    size: '2rem',
    timeOutMs: 300,
    maskStyle: {},
    style: undefined,
  };

  static propTypes = {
    borderRadius: PropTypes.string,
    children: PropTypes.node,
    isLoading: PropTypes.bool,
    size: PropTypes.string,
    timeOutMs: PropTypes.number,
    maskStyle: PropTypes.object,
    style: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.timeOutMs === 0 && this.props.isLoading,
    };
  }

  componentDidMount() {
    this.showOverlay();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isLoading !== prevProps.isLoading &&
      !this.props.isLoading &&
      this.timerIsDone
    ) {
      this.setState({
        isLoading: false,
      });
    }

    // show spinner again - this happens if the `isLoading` prop keeps getting
    // toggled on the same instance of this class
    if (this.props.isLoading === true && prevProps.isLoading === false) {
      this.timerIsDone = false;
      this.showOverlay();
    }
  }

  showOverlay = () => {
    // We only show the loading overlay if the inner content
    // has taken a long time to load (longer than 300ms by default)
    // This is to prevent quick flashes of the loading mask
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => {
      this.timerIsDone = true;
      if (this.props.isLoading) {
        this.setState({
          isLoading: true,
        });
      }
    }, this.props.timeOutMs);
  };

  render() {
    return (
      <div style={{ position: 'relative', ...this.props.style }}>
        <If condition={this.state.isLoading}>
          <Mask
            borderRadius={this.props.borderRadius}
            style={this.props.maskStyle}
          >
            <Spinner size={this.props.size} />
          </Mask>
        </If>
        {this.props.children}
      </div>
    );
  }
}
